import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './language.json';

const Language = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Linguistics, language learning, and multilingualism vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Language"
            image="/Images/createwords1.webp"
            seoTitle="Free English Lesson Plans: Language"
            seoDescription="Linguistics, language learning, and multilingualism vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Language;


